var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "notice-detail" },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("customer::customers-notice::activity_info"))),
      ]),
      _c(
        "el-form",
        { staticClass: "form" },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("customer::customers-notice::avtivity_name"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.emailModel.name) + " ")]
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("customer::customers-notice::email_obj") },
            },
            [_vm._v(" " + _vm._s(_vm.checkReceiver(_vm.emailModel)) + " ")]
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("customer::customers-notice::send_time") },
            },
            [_vm._v(" " + _vm._s(_vm.emailModel.sentDate) + " ")]
          ),
        ],
        1
      ),
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("customer::customers-notice::emial_content"))),
      ]),
      _c("RichEditor", {
        attrs: { placeholder: _vm.$t("customer::customers-notice::content") },
        model: {
          value: _vm.emailModel.content,
          callback: function ($$v) {
            _vm.$set(_vm.emailModel, "content", $$v)
          },
          expression: "emailModel.content",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }